import axios, { AxiosInstance } from "axios"
import api from "@/services/api"
import { Format, Layout } from "@/types/format"

class FormatApi {
	private get axios (): AxiosInstance {
		return api.getAxios()
	}

	public async formatGet (): Promise<Format[]> {
		return (await this.axios.get("/format")).data
	}

	public async layoutsGet (): Promise<Layout[]> {
		return (await this.axios.get("/format/layouts")).data
	}

	public async formatSave (format: Format): Promise<Format> {
		return (await this.axios.post("/format", format)).data
	}

	public async formatDelete (format: Format): Promise<Format> {
		return (await this.axios.delete(`/format/${format.id}`)).data
	}
}

const formatApi = new FormatApi()
export default formatApi
